import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";

const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const Stripe = ({ isSetup, redirectUrl, onPaymentFail = () => { } }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return null;
    }
    const return_url = redirectUrl
      ? window.location.origin + redirectUrl
      : window.location.href;

    const inIframe = isInIframe();

    if (isSetup) {
      if (inIframe) {
        // Use redirect: 'if_required' to prevent Stripe from redirecting the
        // top-level window, which would break out of the iframe.
        const { error, setupIntent } = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url,
          },
          redirect: "if_required",
        });

        if (error) {
          setErrorMessage(error.message);
        } else if (setupIntent && setupIntent.status === "succeeded") {
          window.parent?.postMessage?.("ticket-checkout-success", "*");
          window.location.href = return_url;
        }
      } else {
        const { error } = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url,
          },
        });

        if (error) {
          setErrorMessage(error.message);
        }
      }
    } else {
      if (inIframe) {
        // Use redirect: 'if_required' to prevent Stripe from redirecting the
        // top-level window, which would break out of the iframe.
        const { error, paymentIntent } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url,
          },
          redirect: "if_required",
        });

        if (error) {
          onPaymentFail();
          setErrorMessage(error.message);
        } else if (
          paymentIntent &&
          (paymentIntent.status === "succeeded" ||
            paymentIntent.status === "requires_capture")
        ) {
          window.parent?.postMessage?.("ticket-checkout-success", "*");
          window.location.href = return_url;
        }
      } else {
        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url,
          },
        });

        if (error) {
          onPaymentFail();
          setErrorMessage(error.message);
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "0rem",
          marginBottom: "0rem",
        }}
      >
        <button
          disabled={!stripe}
          className="btn btn--primary"
          style={{
            backgroundColor: "black",
            color: "white",
          }}
        >
          Submit
        </button>
      </div>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </form>
  );
};

export default Stripe;
